import React from "react";
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import userRoles from '../helpers/role';


class SubBannerShip extends React.Component {

    ClearLRForm = () => {
        this.props.dispatch({ type: "getLRFormPDFSuccess", data: "" });
    }

    render() {
        const { TEForm } = this.props;
        let userrole = localStorage.getItem("UserRoles");
        let shipId = JSON.parse(localStorage.getItem("shipId"));
        // let TEForm = localStorage.getItem("TEFormApplicable");
        return (
            <div>
                <div className="sub-banner" style={{ width: "100%", zIndex: '1' }}>

                    {TEForm && TEForm === true ?

                        <div className="row w-100">

                            <div className={userrole == userRoles.mmpl || userrole == userRoles.mmpladmin ? "col-sm-12 col-md-1" : "col-sm-12 col-md-1"} style={{ minWidth: "14%" }}>
                                <div className="page-head-submenu p-1">
                                    <NavLink strict to={`/Home/Ship/${shipId}/Tasks`} activeClassName="active-link-submenu">
                                        <h2>Ship's Pending Tasks</h2>
                                    </NavLink>
                                </div>
                            </div>

                            <div className={userrole == userRoles.mmpl || userrole == userRoles.mmpladmin ? "col-sm-12 col-md-1" : "col-sm-12 col-md-1"} style={{ minWidth: "15%" }}>
                                <div className="page-head-submenu p-1">
                                    <NavLink exact to={`/Home/Ship/${shipId}/MaintenanceRevision`} activeClassName="active-link-submenu" onClick={() => this.ClearLRForm()}>
                                        <h2>IHM Maintenance Revision</h2>
                                    </NavLink>
                                </div>
                            </div>

                            <div className={userrole == userRoles.mmpl || userrole == userRoles.mmpladmin ? "col-sm-12 col-md-1" : "col-sm-12 col-md-1"} style={{ minWidth: "14%" }}>
                                <div className="page-head-submenu p-1">
                                    <NavLink exact to={`/Home/Ship/${shipId}/Certificates`} activeClassName="active-link-submenu">
                                        <h2>Certificates & Documents</h2>
                                    </NavLink>
                                </div>
                            </div>

                            <div className={userrole == userRoles.mmpl || userrole == userRoles.mmpladmin ? "col-sm-12 col-md-1" : "col-sm-12 col-md-1"} style={{ minWidth: "17%" }}>
                                <div className="page-head-submenu p-1">
                                    <NavLink onClick={() => {
                                        this.props.dispatch({
                                            type: "MaterialValidationSearch",
                                            data: null
                                        });
                                    }} exact to={`/Home/Ship/${shipId}/MaterialValidation`} activeClassName="active-link-submenu">
                                        <h2>PO Hazardous Material Validation</h2>
                                    </NavLink>
                                </div>
                            </div>
                            {userrole == userRoles.mmpl || userrole == userRoles.mmpladmin ?
                                <div className={userrole == userRoles.mmpl || userrole == userRoles.mmpladmin ? "col-sm-12 col-md-1" : "col-sm-12 col-md-1"} style={{ minWidth: "15%" }}>
                                    <div className="page-head-submenu p-1">
                                        <NavLink exact to={`/Home/Ship/${shipId}/SixMonthReview`} activeClassName="active-link-submenu">
                                            <h2>Six Month Review</h2>
                                        </NavLink>
                                    </div>
                                </div> : null}

                            <div className={userrole == userRoles.mmpl || userrole == userRoles.mmpladmin ? "col-sm-12 col-md-1" : "col-sm-12 col-md-1"} style={{ minWidth: "15%" }}>
                                <div className="page-head-submenu p-1">
                                    <NavLink exact to={`/Home/Ship/${shipId}/ShipDocument`} activeClassName="active-link-submenu">
                                        <h2>IHM Reference Documents</h2>
                                    </NavLink>
                                </div>
                            </div>

                            <div className={userrole == userRoles.mmpl || userrole == userRoles.mmpladmin ? "col-sm-12 col-md-1" : "col-sm-12 col-md-1"} style={{ minWidth: "10%" }}>
                                <div className="page-head-submenu p-1">
                                    <NavLink exact to={`/Home/Ship/${shipId}/TEForms`} activeClassName="active-link-submenu">
                                        <h2>TE Forms</h2>
                                    </NavLink>
                                </div>
                            </div>
                        </div>

                        :

                        <div className="row w-100">

                            <div className={userrole == userRoles.mmpl || userrole == userRoles.mmpladmin ? "col-sm-12 col-md-2" : "col-sm-12 col-md-2"} >
                                <div className="page-head-submenu p-1">
                                    <NavLink strict to={`/Home/Ship/${shipId}/Tasks`} activeClassName="active-link-submenu">
                                        <h2>Ship's Pending Tasks</h2>
                                    </NavLink>
                                </div>
                            </div>

                            <div className={userrole == userRoles.mmpl || userrole == userRoles.mmpladmin ? "col-sm-12 col-md-2" : "col-sm-12 col-md-2"} >
                                <div className="page-head-submenu p-1">
                                    <NavLink exact to={`/Home/Ship/${shipId}/MaintenanceRevision`} activeClassName="active-link-submenu" onClick={() => this.ClearLRForm()}>
                                        <h2>IHM Maintenance Revision</h2>
                                    </NavLink>
                                </div>
                            </div>

                            <div className={userrole == userRoles.mmpl || userrole == userRoles.mmpladmin ? "col-sm-12 col-md-2" : "col-sm-12 col-md-2"} >
                                <div className="page-head-submenu p-1">
                                    <NavLink exact to={`/Home/Ship/${shipId}/Certificates`} activeClassName="active-link-submenu">
                                        <h2>Certificates & Documents</h2>
                                    </NavLink>
                                </div>
                            </div>

                            <div className={userrole == userRoles.mmpl || userrole == userRoles.mmpladmin ? "col-sm-12 col-md-2" : "col-sm-12 col-md-2"} >
                                <div className="page-head-submenu p-1">
                                    <NavLink exact to={`/Home/Ship/${shipId}/MaterialValidation`} activeClassName="active-link-submenu">
                                        <h2>PO Hazardous Material Validation</h2>
                                    </NavLink>
                                </div>
                            </div>
                            {userrole == userRoles.mmpl || userrole == userRoles.mmpladmin ?
                                <div className={userrole == userRoles.mmpl || userrole == userRoles.mmpladmin ? "col-sm-12 col-md-2" : "col-sm-12 col-md-2"} >
                                    <div className="page-head-submenu p-1">
                                        <NavLink exact to={`/Home/Ship/${shipId}/SixMonthReview`} activeClassName="active-link-submenu">
                                            <h2>Six Month Review</h2>
                                        </NavLink>
                                    </div>
                                </div> : null}

                            <div className={userrole == userRoles.mmpl || userrole == userRoles.mmpladmin ? "col-sm-12 col-md-2" : "col-sm-12 col-md-2"} >
                                <div className="page-head-submenu p-1">
                                    <NavLink exact to={`/Home/Ship/${shipId}/ShipDocument`} activeClassName="active-link-submenu">
                                        <h2>IHM Reference Documents</h2>
                                    </NavLink>
                                </div>
                            </div>

                            {/* <div className="col-sm-12">
                            <ul id="nav">
                                <li>
                                    <div className="page-head-submenu">
                                        <NavLink exact to={`/Home/Ship/${shipId}/Tasks`} activeClassName="active-link-submenu">
                                            <h2>Pending Tasks</h2>
                                        </NavLink>
                                    </div>
                                </li>
                                <li>
                                    <div className="page-head-submenu">
                                        <NavLink exact to={`/Home/Ship/${shipId}/MaintenanceRevision`} activeClassName="active-link-submenu">
                                            <h2>IHM Maintenance Revision</h2>
                                        </NavLink>
                                    </div>
                                </li>
                                <li>
                                    <div className="page-head-submenu">
                                        <NavLink exact to={`/Home/Ship/${shipId}/Certificates`} activeClassName="active-link-submenu">
                                            <h2>Certificates</h2>
                                        </NavLink>
                                    </div>
                                </li>
                                <li>
                                    <div className="page-head-submenu">
                                        <NavLink exact to={`/Home/Ship/${shipId}/MaterialValidation`} activeClassName="active-link-submenu">
                                            <h2>PO Hazardess Material Validation</h2>
                                        </NavLink>
                                    </div>
                                </li>
                            </ul>
                        </div> */}
                        </div>}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        Role: state.SidePanReducer.UserRole || null,
        TEForm: state.ShipViewReducer.TEForm,
    }
}

export default connect(mapStateToProps, null)(SubBannerShip);